import '../../../jello/node_modules/bootstrap';
import detectIt from 'detect-it';
import MenuTabs from './menu-tabs';

export default class Menu {
  constructor() {
    this.mainMenu = $('.menu-primary');
    this.metaMenu = $('.menu-meta-wrap');
    this.searchLink = $('.btn-search');
    this.toggler = $('.navbar-toggler');
    this.btnPhone = $('.btn-phone');

    this.handleSizes();
    this.handleSearch();
    Menu.handleDevices();
  }

  static handleDevices() {
    if (detectIt.deviceType === 'touchOnly') {
      Menu.addTouchFunctionality();
    }
  }

  handleSearch() {
    this.toggler.on('click', (e) => {
      e.preventDefault();

      if (this.toggler.hasClass('collapsed')) {
        this.btnPhone.hide();
        $(document).scrollTop(0);
      } else {
        this.btnPhone.show();
      }

      const body = $('body');
      const header = $('header');
      
      body.toggleClass('body-overlay');
      header.toggleClass('dont-stick');
      
      setTimeout(() => body.toggleClass('show-overlay'), 50);
    });

    this.searchLink.on('click', (e) => {
      e.preventDefault();

      if ($(window).width() < 1200) {
        return; // do not handle click, button is just for display
      }

      const btn = $(e.currentTarget);
      const container = btn.parent();
      const form = container.children('.searchform');
      const input = form.children('input');

      if (form.hasClass('visible')) {
        btn.removeClass('in-search-mode');
        form.removeClass('visible').fadeOut(100);
      } else {
        btn.addClass('in-search-mode');
        form.fadeIn(100, () => {
          input.focus();
        }).addClass('visible');
      }
    });
  }

  handleSizes() {
    if ($(window).width() < 1200) {
      this.repeatParentInSubmenu();
      this.moveMetaToMain();
      this.menuTabs = new MenuTabs();
    } else if (this.menuTabs) {
      this.menuTabs.destroy();
    }
  }

  /**
   * Meta menu gets added to the mobile menu,
   * this function places it back
   */
  static placeMetaBack() {
    const $meta = $('.menu-meta');
    const $main = $('.menu-main');
    const $mobileMenu = $('.header .menu-main-container');

    $($meta, $mobileMenu).insertAfter($main);
    $meta.removeClass('visible');
  }

  repeatParentInSubmenu() {
    const parents = $('.menu-item-has-children > .nav-link', this.mainMenu);
    
    parents.each(function repeatParent() {
      let holder = $('+ .sub-menu', $(this));
      if ($('> .nav-col', holder)) {
        holder = $('> .nav-col > .sub-menu', holder);
      }

      $(this)
        .clone()
        .prependTo(holder.eq(0))
        .wrap('<li></li>')
        .parent()
        .addClass($(this).parent().attr('class'))
        .addClass('menu-item-copied')
        .removeClass('menu-item-has-children nav-cols');
    });
  }

  moveMetaToMain() {
    this.metaMenu = this.mainMenu.after(this.metaMenu);
  }

  /**
   * Sets up the menu so users with touch devices can
   * reveal submenus without navigating away.
   * 
   * @todo Close submenu when clicking the link again
   */
  static addTouchFunctionality() {
    const itemWithChildren = $('.menu > .menu-item-has-children > a');

    itemWithChildren.on('click', (e) => {
      e.preventDefault();
    });
  }
}
